import goTop from '@/components/goTop.vue';
import VueCookies from 'vue-cookies';
export default {
  components: {
    goTop
  },
  data() {
    return {};
  },
  mounted() {
    const cookies = VueCookies;
    cookies.set("isMobile", this._isMobile(), "30D");
  },
  methods: {
    //App.vue
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
      return !!flag ? 1 : 0;
    }
  }
};